import React from "react";
import "../designcss/Helpingbusiness.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import GetStartedNow from "./GetStartedNow";
import FAQ from "./FAQ";
import Chatboxrepliespage from "./Chatboxrepliespage";
import ChatboxWhatwedo from "./ChatboxWhatwedo";
const AutomatedReply = () => {
  return (
    <>
      <Navbar />
      <Chatboxrepliespage />
      <div className="business-wrapper">
        <div className="business-container">
          <div className="grows-smarter">
            <h1>What Are Automated Replies and Smart Flows</h1>
            {/* <h1>with WhatsApp Automation</h1> */}
          </div>

          <p className="business-api">
            Automated replies are pre-configured messages that are sent
            automatically when a user takes a specific action, like sending a
            message or clicking a button. Smart flows go further by creating
            dynamic conversation paths that adjust based on user responses,
            guiding customers step by step toward the information or action they
            need.
          </p>

          <div className="vision-mission-container">
            <div className="cardd vision-card">
              <h3>Why Automation Is Essential for WhatsApp Communication</h3>
              <p>
                As customer interactions grow, manually replying to every query
                becomes inefficient. Automation ensures every message is handled
                quickly and consistently, even outside business hours. Smart
                automation speeds up responses, reduces support workload, and
                maintains uniform messaging across all customer interactions.
              </p>
            </div>

            <div className="cardd mission-card">
              <h3>WoSender Powers Intelligent Automation</h3>
              <p>
                WoSender provides advanced automation tools that simplify
                WhatsApp communication for businesses of all sizes. Brands can
                create instant replies to common queries, design multi-step
                smart flows with buttons and quick replies, and direct
                conversations based on user choices, making interactions more
                effective and engaging.
              </p>
            </div>
          </div>
        </div>
      </div>
      <ChatboxWhatwedo />
      <FAQ />
      <GetStartedNow />

      <Footer />
    </>
  );
};

export default AutomatedReply;
